module.exports = __webpack_public_path__ + "fonts/Inter-400-greek-ext45.af80f40.woff2";